var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBread(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 3C5.11929 3 4 4.11929 4 5.5C4 6.68576 4.82552 7.6787 5.93318 7.93547L5.07652 19.9288C5.03517 20.5076 5.49363 21 6.07398 21H17.926C18.5064 21 18.9648 20.5076 18.9235 19.9288L18.0668 7.93547C19.1745 7.6787 20 6.68576 20 5.5C20 4.11929 18.8807 3 17.5 3H6.5ZM13.4939 10.5644L9.49388 14.0644C9.18215 14.3372 8.70833 14.3056 8.43557 13.9939C8.16281 13.6822 8.19439 13.2083 8.50612 12.9356L12.5061 9.43557C12.8178 9.16281 13.2917 9.19439 13.5644 9.50612C13.8372 9.81785 13.8056 10.2917 13.4939 10.5644ZM15.0644 12.5061C15.3372 12.8178 15.3056 13.2917 14.9939 13.5644L10.9939 17.0644C10.6822 17.3372 10.2083 17.3056 9.93557 16.9939C9.66281 16.6822 9.69439 16.2083 10.0061 15.9356L14.0061 12.4356C14.3178 12.1628 14.7917 12.1944 15.0644 12.5061Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBread);
export default __webpack_public_path__ + "static/media/bread.b278d94fae3b780067da5c965bea9e27.svg";
export { ForwardRef as ReactComponent };